import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { authHeader, fetchWrapper } from '../_helpers';

// create slice

const name = 'notifications';
const initialState = createInitialState();
const reducers = createReducers()
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const notificationActions = { ...slice.actions, ...extraActions };
export const notificationReducer = slice.reducer;

// implementation
function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        notifications: [],
        // showCreateEventsModal: false,
        error: null,
    }
}

function createReducers() {
    return {
        // showCreateEventsModal
    }

    function showCreateEventsModal(state, action) {
        state.showCreateEventsModal = action.payload;
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/auth/notifications`;

    return {
        //createEvent: createEvent(),
        getNotifications: getNotifications(),
        deleteNotification: deleteNotification()
    };

    function createEvent() {
        return createAsyncThunk(
            `${name}/events/create`,
            async (data, { dispatch }) => {
                const options = {
                    method: 'POST',
                    body: data,
                    headers: {
                        ...authHeader()
                    }
                };

                return await fetchWrapper.custom(baseUrl, options, () => dispatch(notificationActions.getEvents()), dispatch)
            }
        );
    }

    function getNotifications() {

        return createAsyncThunk(
            `${name}/notifications/fetch`,
            async (data, { dispatch }) => await fetchWrapper.post(baseUrl, data, null, dispatch)
        );
    }

    function deleteNotification() {
        return createAsyncThunk(
            `${name}/notifications/delete`,
            async (data, { dispatch }) => {
                const body = {
                    "action": "fetch"
                }
                await fetchWrapper.delete(baseUrl, data, () => dispatch(notificationActions.getNotifications(body)), dispatch)
            }
        );
    }


}

function createExtraReducers() {
    return {
        ...getNotifications(),
        ...deleteNotification()
    };

    function getNotifications() {
        var { pending, fulfilled, rejected } = extraActions.getNotifications;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                state.notifications = action.payload;
            },
            [rejected]: (state, action) => {
                state.error = action.error;
            }
        };
    }

    function deleteNotification() {
        var { pending, fulfilled, rejected } = extraActions.deleteNotification;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                state.notifications = action.payload;
            },
            [rejected]: (state, action) => {
                state.error = action.error;
            }
        };
    }
}
